export const PARTNER_AGREEMENT_PENDING_TITLE = 'Ждём ответ от Альфа-Банка';

export const PARTNER_AGREEMENT_PENDING_DESCRIPTION =
	'Мы отправили запрос на проверку данных. Нужно немного подождать';

export const PARTNER_AGREEMENT_PENDING_ACTION_LABEL = 'Окей, жду';
